import {IntermediatePart} from "../../intermediatePart";

export default class RightWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'right_wall';
    this.partName = 'Right Wall';
    this.translateId = "visualizer.kitchen.walls.right_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new RightWall());
  }
}
